import withClassName from '../withClassName';
import { IconProps } from '../types';

const DownCircleFilled = (props: IconProps): JSX.Element => {
	return (
		<svg
			viewBox='0 0 1000 1000'
			data-icon='down-circle'
			fill='currentColor'
			aria-hidden='true'
			height='1.5em'
			width='1.5em'
			className='ee-svg--down-circle-filled'
			{...props}
		>
			<path d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm184.5 353.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z' />
		</svg>
	);
};

export default withClassName(DownCircleFilled, 'down-circle-filled');
